function SvgCheck(props) {
  return (
    <svg
      width={12}
      height={9}
      viewBox="0 0 12 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.379 7.844a.519.519 0 00.723 0l5.742-5.742a.519.519 0 000-.723L10.14.676a.495.495 0 00-.704 0L4.75 5.363 2.543 3.176a.495.495 0 00-.703 0l-.703.703a.519.519 0 000 .723l3.242 3.242z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SvgCheck
